import { render, staticRenderFns } from "./error-image.vue?vue&type=template&id=50042841&scoped=true&"
import script from "./error-image.vue?vue&type=script&lang=js&"
export * from "./error-image.vue?vue&type=script&lang=js&"
import style0 from "./error-image.vue?vue&type=style&index=0&id=50042841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50042841",
  null
  
)

export default component.exports